// ヘルプメッセージ
import React from 'react';
import { convertLine } from '../Convert';
var HelpMessage = function (_a) {
    var help_msg = _a.help_msg;
    var replaceReturnCode = function (msg) {
        if (msg === null || typeof msg === 'undefined') {
            return msg;
        }
        return React.createElement(React.Fragment, null, convertLine(msg));
    };
    return (React.createElement(React.Fragment, null, help_msg && (React.createElement("div", null,
        React.createElement("span", { className: "help-msg" },
            React.createElement("strong", { className: "paragraph" }, replaceReturnCode(help_msg)))))));
};
export default HelpMessage;
